// <div data-controller="components--clipboard">
// </div>
import {Controller} from "@hotwired/stimulus";
export default class extends Controller {
  static targets = [ ""];
  static values = {
    text: String,
  }

  copyToClipboard(e) {
    window.navigator.clipboard.writeText(this.textValue).then(() => {
      alert(`복사됨 : ${this.textValue}`);
    });
  }

  connect() {
  }

  disconnect() {
  }
}